import { render } from "./RecoveryPassword.vue?vue&type=template&id=64ee7dcd"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/auth/RecoveryPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64ee7dcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64ee7dcd', __exports__)) {
    api.reload('64ee7dcd', __exports__)
  }
  
  module.hot.accept("./RecoveryPassword.vue?vue&type=template&id=64ee7dcd", () => {
    api.rerender('64ee7dcd', render)
  })

}


export default __exports__